import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialogModule } from '@angular/material/dialog';

import { StoreHeaderComponent } from '../store-header/store-header.component';
import { PhoneMaskDirective } from '../_helpers/phone-mask-directive';
import { MenuComponent } from '../store-lazy/menu/menu.component';
import { MenuGroupItemsComponent } from '../store-lazy/menu-group-items/menu-group-items.component';

@NgModule({
  declarations: [
    StoreHeaderComponent,
    MenuComponent,
    MenuGroupItemsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PhoneMaskDirective,
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatMenuModule,
    MatExpansionModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatBottomSheetModule,
    MatDialogModule,
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatMenuModule,
    MatExpansionModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatBottomSheetModule,
    MatDialogModule,
    StoreHeaderComponent,
    PhoneMaskDirective,
    MenuComponent,
    MenuGroupItemsComponent,
  ],
})
export class SharedModule {}
